<template>
  <div class="package-view-page w-100">
    <!-- Header -->
    <div class="w-100 px-8 py-4 bg-white border-bottom">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
        
          <div>
            <h5 class="mb-0 font-weight-bold text-dark">
              {{ detail ? detail.name : 'Chi tiết gói dịch vụ' }}
            </h5>
            <small class="text-muted">Chi tiết gói dịch vụ</small>
          </div>
        </div>
         <div class="">
           <b-button variant="secondary" class="mr-2"  @click="goBack">
            <i class="fas fa-arrow-left"></i> Quay lại
          </b-button>
        <b-button variant="success" @click="goEdit">
          <i class="far fa-edit mr-2"></i>Chỉnh sửa
        </b-button>
         </div>
      </div>
    </div>

    <!-- Content -->
    <b-overlay :show="loading">
      <div class="container-fluid py-6">
        <div class="row justify-content-center">
          <div class="col-lg-9" v-if="detail">

            <!-- Overview card -->
            <div class="detail-section mb-5">
              <div class="d-flex align-items-center mb-3">
                <h5 class="mb-0 font-weight-bold text-dark mr-3">{{ detail.name }}</h5>
                <span
                  :class="{
                    'status-draft':    detail.status === 0,
                    'status-active':   detail.status === 1,
                    'status-inactive': detail.status === 2,
                  }"
                  class="status-badge"
                >
                  {{ detail.status === 0 ? 'Nháp' : detail.status === 1 ? 'Hoạt động' : 'Không hoạt động' }}
                </span>
              </div>
              <p v-if="detail.description" class="text-muted mb-5">{{ detail.description }}</p>

              <!-- Stat cards -->
              <div class="row">
                <div class="col-md-4 mb-4">
                  <div class="stat-card stat-card--blue">
                    <div class="stat-card__label">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-tag-fill" viewBox="0 0 16 16">
                      <path d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
                    </svg>
                      Giá bán
                    </div>
                    <div class="stat-card__value">
                      {{ formatPrice(detail.salePrice) }} VNĐ
                    </div>
                    <div v-if="detail.salePrice > 0 && detail.salePrice < detail.price" class="stat-card__sub">
                      <span class="text-decoration-line-through text-muted mr-2">
                        {{ formatPrice(detail.price) }} VNĐ
                      </span>
                      <span class="text-success font-weight-bold">
                        Tiết kiệm {{ savingPercent(detail.price, detail.salePrice) }}%
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 mb-4">
                  <div class="stat-card stat-card--green">
                    <div class="stat-card__label">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-fill" viewBox="0 0 16 16">
                          <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16V4H0V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5"/>
                        </svg>
                      Thời hạn sử dụng
                    </div>
                    <div class="stat-card__value">{{ detail.duration }} tháng</div>
                    <div class="stat-card__sub text-muted">Kể từ ngày đăng ký</div>
                  </div>
                </div>

                <div class="col-md-4 mb-4">
                  <div class="stat-card stat-card--orange">
                    <div class="stat-card__label">
                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-seam-fill" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.01-.003.268-.108a.75.75 0 0 1 .558 0l.269.108.01.003zM10.404 2 4.25 4.461 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339L8 5.961 5.596 5l6.154-2.461z"/>
                    </svg>
                    Ngày tạo
                    </div>
                    <div class="stat-card__value">{{ formatDate(detail.createDatetime) }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="resolvedMedicines.length > 0" class="detail-section mb-5">
              <h5 class="font-weight-bolder text-dark">
                Thuốc &amp; Thực phẩm chức năng
                <span class="count-badge">({{ resolvedMedicines.length }})</span>
              </h5>
              <div class="item-list">
                <div
                  v-for="item in resolvedMedicines"
                  :key="item.itemId"
                  class="item-row"
                >
                  <div class="item-row__info">
                    <span class="item-row__name">{{ item.name || item.itemId }}</span>
                    <span v-if="item.description" class="item-row__sub text-muted">{{ item.description }}</span>
                  </div>
                  <div class="item-row__right">
                    <div class="item-row__qty">{{ item.isUnlimited ? 'Không giới hạn' : 'x' + item.count }}</div>
                    <div v-if="item.price" class="item-row__price text-muted">
                      {{ formatPrice(item.price) }}/{{ item.unit }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="resolvedServicePackages.length > 0" class="detail-section mb-5">
              <h5 class="font-weight-bolder text-dark">
                Chương trình
                <span class="count-badge">({{ resolvedServicePackages.length }})</span>
              </h5>
              <div class="item-list">
                <div
                  v-for="item in resolvedServicePackages"
                  :key="item.itemId"
                  class="item-row"
                >
                  <div class="item-row__info">
                    <span class="item-row__name">{{ item.name || item.itemId }}</span>
                    <span v-if="item.description" class="item-row__sub text-muted">{{ item.description }}</span>
                  </div>
                  <div class="item-row__right">
                    <div class="item-row__qty">{{ item.isUnlimited ? 'Không giới hạn' : 'x' + item.count }}</div>
                    <div v-if="item.money" class="item-row__price text-muted">
                      {{ formatPrice(item.money) }} VNĐ
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="resolvedServices.length > 0" class="detail-section mb-5">
             <h5 class="font-weight-bolder text-dark">
                Dịch vụ khám &amp; điều trị
                <span class="count-badge">({{ resolvedServices.length }})</span>
              </h5>
              <div class="item-list">
                <div
                  v-for="item in resolvedServices"
                  :key="item.itemId"
                  class="item-row"
                >
                  <div class="item-row__info">
                    <span class="item-row__name">{{ item.name || item.itemId }}</span>
                    <span class="item-row__sub">
                      <!-- <span v-if="item.category" class="text-primary">{{ item.category }}</span> -->
                      <span v-if="item.minutes" class="text-muted">
                        {{ item.category ? ' • ' : '' }}{{ item.minutes }} phút
                      </span>
                      <template v-if="item.description">
                        <br />
                        <span class="text-muted">{{ item.description }}</span>
                      </template>
                    </span>
                  </div>
                  <div class="item-row__right">
                    <div class="item-row__qty">{{ item.isUnlimited ? 'Không giới hạn' : item.count + ' lần' }}</div>
                    <div v-if="item.price" class="item-row__price text-muted">
                      {{ formatPrice(item.price) }} VNĐ/lần
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty -->
            <div
              v-if="resolvedMedicines.length === 0 && resolvedServicePackages.length === 0 && resolvedServices.length === 0 && !loading"
              class="detail-section text-center text-muted py-8"
            >
              <i class="fas fa-box-open fa-2x mb-3 d-block"></i>
              Gói chưa có mục nào
            </div>

          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: 'PackageManagementView',
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      detail: null,
      medicineMap: {},
      servicePackageMap: {},
      serviceMap: {},
    };
  },

  computed: {
    itemsByType() {
      const items = this.detail?.items || [];
      return {
        medicines:       items.filter((i) => i.itemType === 0),
        servicePackages: items.filter((i) => i.itemType === 1),
        services:        items.filter((i) => i.itemType === 2),
      };
    },

    resolvedMedicines() {
      return this.groupAndResolve(this.itemsByType.medicines, this.medicineMap);
    },

    resolvedServicePackages() {
      return this.groupAndResolve(this.itemsByType.servicePackages, this.servicePackageMap);
    },

    resolvedServices() {
      return this.groupAndResolve(this.itemsByType.services, this.serviceMap);
    },
  },

  created() {
    this.init();
  },

  methods: {
  
    groupAndResolve(items, lookup) {
      const grouped = {};
      items.forEach((item) => {
        const key = item.itemId;
        if (grouped[key]) {
          if (!grouped[key].isUnlimited) {
            grouped[key].count += item.quantity || 1;
          }
        } else {
          grouped[key] = {
            itemId: key,
            isUnlimited: item.isUnlimited === 1,
            count: item.isUnlimited === 1 ? 0 : (item.quantity || 1),
            ...(lookup[key] || { name: key }),
          };
        }
      });
      return Object.values(grouped);
    },

    async init() {
      this.loading = true;
      try {
        await Promise.all([
          this.loadDetail(),
          this.loadMedicines(),
          this.loadServicePackages(),
          this.loadServices(),
        ]);
      } finally {
        this.loading = false;
      }
    },

    async loadDetail() {
      if (!this.id) return;
      try {
        const { data } = await this.$api.get(`SalePackage/${this.id}`);
        this.detail = data;
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: 'Không thể tải thông tin gói dịch vụ' });
        this.goBack();
      }
    },

    async loadMedicines() {
      try {
        const { data } = await this.$api.get('BundleMedicine/All');
        const list = data || [];
        const map = {};
        list.forEach((m) => { if (m.id) map[m.id] = m; });
        this.medicineMap = map;
      } catch (e) {
        console.error('Không thể tải danh sách thuốc:', e);
      }
    },

    async loadServicePackages() {
      try {
        const { data } = await this.$api.get('ServicePackage', { params: { size: 1000 } });
        const list = data?.items || data || [];
        const map = {};
        list.forEach((p) => { if (p.id) map[p.id] = p; });
        this.servicePackageMap = map;
      } catch (e) {
        console.error('Không thể tải danh sách gói dịch vụ:', e);
      }
    },

    async loadServices() {
      try {
        const { data } = await this.$api.get('BundleService/All');
        const list = data || [];
        const map = {};
        list.forEach((s) => { if (s.id) map[s.id] = s; });
        this.serviceMap = map;
      } catch (e) {
        console.error('Không thể tải danh sách dịch vụ:', e);
      }
    },

    formatPrice(price) {
      if (!price && price !== 0) return '0';
      return new Intl.NumberFormat('vi-VN').format(price);
    },

    formatDate(timestamp) {
      if (!timestamp) return '';
      const ms =
        typeof timestamp === 'number' && timestamp < 1e12
          ? timestamp * 1000
          : timestamp;
      return this.$moment(ms).format('D/M/YYYY');
    },

    savingPercent(original, sale) {
      if (!original || original === 0) return 0;
      return Math.round(((original - sale) / original) * 100);
    },

    goBack() {
      this.$router.push({ name: 'package_management' });
    },

    goEdit() {
      this.$router.push({
        name: 'package_management_edit',
        params: { id: this.id },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.package-view-page {
  background-color: #f8f9fa;
  min-height: 100vh;
}

.detail-section {
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 12px;
  padding: 24px 28px;
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #181c32;
  margin-bottom: 16px;

  .count-badge {
    font-size: 0.9rem;
    color: #a1a5b7;
    font-weight: 400;
  }
}

/* Status badge */
.status-badge {
  display: inline-block;
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 0.82rem;
  font-weight: 600;
}
.status-draft    { background: #f3f4f8; color: #7e8299; }
.status-active   { background: #e8fff3; color: #50cd89; }
.status-inactive { background: #fff5f8; color: #f1416c; }

/* Stat cards */
.stat-card {
  border-radius: 10px;
  padding: 18px 20px;
  height: 100%;

  &__label {
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 10px;
  }
  &__value {
    font-size: 1.5rem;
    font-weight: 700;
    color: #181c32;
    line-height: 1.2;
    margin-bottom: 6px;
  }
  &__sub {
    font-size: 0.8rem;
  }

  &--blue   { background: #eef6ff; .stat-card__label { color: #3699ff; } }
  &--green  { background: #e8fff3; .stat-card__label { color: #50cd89; } }
  &--orange { background: #fff5e5; .stat-card__label { color: #f6a619; } }
}

/* Item rows */
.item-list {
  display: flex;
  flex-direction: column;
}

.item-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 13px 0;
  border-bottom: 1px solid #f3f4f8;

  &:last-child { border-bottom: none; }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }

  &__name {
    font-size: 0.95rem;
    font-weight: 600;
    color: #181c32;
  }

  &__sub {
    font-size: 0.82rem;
    line-height: 1.5;
  }

  &__right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    margin-left: 16px;
  }

  &__qty {
    font-size: 0.9rem;
    font-weight: 600;
    color: #181c32;
  }

  &__price {
    font-size: 0.82rem;
    white-space: nowrap;
  }
}
</style>
